import comp from "./GenericListView";
export default comp;
